import { useMemo, useState } from 'react'
import EstoqueHttp from '../../../../services/api/https/estoque/Estoque.http'
import { errorHandler } from '../../../../services/util/error.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  GET: 'GET',
}

const INITIAL_STATE = {
  itens: [],
  modal: { show: false, data: null },
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
  selectedTp: 0,
  globalFilter: '',
}

export default function useCadastroStatusEtiquetaEstoque() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    return {
      resetState() {
        setState({ ...INITIAL_STATE })
      },
      onInit(selectedTp) {
        setState(prev => ({
          ...prev,
          selectedTp,
          loadingMessage: selectedTp ? LOAD_MESSAGE.GET : LOAD_MESSAGE.NONE,
          errorMessage: selectedTp ? null : 'Selecione um TP',
        }))
      },
      async getStatusEtiqueta(tpId) {
        try {
          const data = await EstoqueHttp.getStatusEtiquetaEstoque(tpId)
          setState(prev => ({ ...prev, itens: data, loadingMessage: LOAD_MESSAGE.NONE }))
        } catch (err) {
          setState(prev => ({
            ...prev,
            loadingMessage: LOAD_MESSAGE.NONE,
            errorMessage: errorHandler(err),
          }))
        }
      },
      onBtnNovo() {
        setState(prev => ({ ...prev, modal: { show: true, data: null } }))
      },
      onModalClose() {
        setState(prev => ({ ...prev, modal: { show: false, data: null } }))
      },
      onModalSave() {
        setState(prev => ({
          ...prev,
          modal: { show: false, data: null },
          loadingMessage: LOAD_MESSAGE.GET,
        }))
      },
      onRowClick(item) {
        setState(prev => ({ ...prev, modal: { show: true, data: item } }))
      },
      onGlobalFilterChange(value) {
        setState(prev => ({ ...prev, globalFilter: value }))
      },
    }
  }, [])

  return { state, localDispatch }
}
